export const hairTips: { description: string; type: string }[] = [
  {
    description: "Use a sulfate-free shampoo to prevent color fading",
    type: "color",
  },
  {
    description: "Deep condition regularly to prevent dryness and damage",
    type: "color",
  },
  {
    description:
      "Limit heat styling and protect your hair with a heat protectant spray if you do use heat tools",
    type: "color",
  },
  {
    description:
      "Use lukewarm or cold water rather than hot water to avoid damaging the hair cuticle",
    type: "color",
  },
  {
    description: "Blow-dry your hair upside down for more lift at the roots",
    type: "volume",
  },
  {
    description:
      "Use volumizing shampoo and conditioner to add body and fullness to your hair",
    type: "volume",
  },
  {
    description:
      "Try teasing your hair at the roots with a teasing comb for a more voluminous look",
    type: "volume",
  },
  {
    description: "Use root lifter mousse or powder for extra lift",
    type: "volume",
  },
  {
    description:
      "Experiment with different hairstyles and accessories to keep things fresh and fun! From braids to buns to headbands, the possibilities are endless",
    type: "styles",
  },
  {
    description: "Consider your face shape when choosing a hairstyle",
    type: "styles",
  },
  { description: "Choose a style that suits your hair type", type: "styles" },
  {
    description: "Take your lifestyle and daily styling time into account",
    type: "styles",
  },
  {
    description:
      "Protect your hair from heat damage by using a heat protectant spray before styling",
    type: "all",
  },
  {
    description:
      "Use a sulfate-free shampoo and conditioner to avoid stripping your hair of its natural oils",
    type: "all",
  },
  {
    description:
      "Use a wide-tooth comb or brush to detangle your hair gently. This will help prevent breakage and split ends",
    type: "all",
  },
  {
    description:
      "Get regular trims to keep your hair looking healthy and prevent split ends. We recommend getting a trim every 6-8 weeks",
    type: "all",
  },
  {
    description:
      "Avoid over-washing your hair, as this can strip your scalp of its natural oils and lead to dry, brittle hair. Aim to wash your hair every 2-3 days",
    type: "all",
  },
  {
    description:
      "Incorporate healthy foods into your diet, such as avocados, nuts, and fatty fish, to promote healthy hair growth from within",
    type: "all",
  },
];

export const hairTipsByType = (type: string) => {
  const tips = JSON.parse(
    JSON.stringify(hairTips.filter((tip) => tip.type === type))
  );
  return shuffle(tips);
};

export const shuffle = (array: any[]) => {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};
